import React from 'react';
import { Layout, routes, pageTypes, siteName, AdMobileAnchor, AdMobileBanner, AdLeaderboard, AdVideo } from 'gatsby-theme-apollo';
import Footer from './footer';
import GameContent from './content';
import EntityList from '../entities/entity-list';
import CTA from '../cta';
import Section from '../layout/section';
import { ContentBox } from '../layout/content-box';
import { Flex } from '../layout/flex';

const EntityHubPage = ({ location, pageContext }) => {
  const pageType = pageTypes.ENTITY_HUB;
  const { gameName, entityType, entities } = pageContext;

  const { description } = entityType;

  const pageTitle = `${entityType.plural} | ${gameName} Wiki | ${siteName}`;
  let pageDescription = `${entityType.plural} stats, guides, tips, and tricks, abilities, and ranks for ${gameName}. `;

  if (description) {
    pageDescription = `${description} ${pageDescription}`;
  }

  const crumbs = [{ text: `${gameName} Wiki`, url: routes.GameHub(gameName), hide: true }];

  return (
    <Layout
      location={location}
      gameName={gameName}
      title={pageTitle}
      description={pageDescription}
      pageType={pageType}
      pageProps={{ entityType: entityType && entityType.plural }}
    >
      <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='47' />
      <GameContent header={`${gameName} ${entityType.plural}`} crumbs={crumbs} showTopShareBar>
        <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
        <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
        {description && 
          <Section justifyContent="center">
            <Flex>
              <ContentBox
                solidBackground
                style={{ padding: `20px`, textAlign: 'left', maxWidth: `900px` }}
              >
                {description}
              </ContentBox>
            </Flex>
          </Section>
        }
        <Section fullWidth justifyContent="center">
          <EntityList
            entities={entities}
            entityType={entityType.plural}
            gameName={gameName}
            limit={85}
            showInterval={25}
            enableShowMore
            enableSearch
          />
        </Section>
        <Footer>
          <AdVideo placementId={'gh-video-' + pageType + '-floating'} />
          <CTA campaignKey="Discord" />
        </Footer>
      </GameContent>
    </Layout>
  );
};

export default EntityHubPage;
